import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { Preloader, ToDashboardError } from '../../components/ui';
import { useConfig } from '../../contexts/config';
import { useCurrentProject } from '../../contexts/settings';
import { useProductAgreement } from '../../hooks';
import NavigationSection from './NavigationPage';

type RouteParams = { projectId: string };

const Navigation = ({ match, history }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { merchantId, xsollaAnalytics } = useConfig();
  const { fetchingAgreement, isAgreementSigned } = useProductAgreement(merchantId);
  const { currentProject, currentProjectFetching, error } = useCurrentProject(projectId);

  useEffect(() => {
    xsollaAnalytics.sendOpen('login_pa_module__navigation_project__open', projectId);
  }, []);

  if (error) {
    return <ToDashboardError error={error} pageName="navigation_project__open" />;
  }

  if (currentProjectFetching || fetchingAgreement) {
    return <Preloader />;
  }

  return (
    <NavigationSection
      isAgreementSigned={isAgreementSigned}
      currentProject={currentProject}
      merchantId={merchantId}
      xsollaAnalytics={xsollaAnalytics}
      projectId={projectId}
      history={history}
    />
  );
};

export default withRouter(Navigation);
